import { render, staticRenderFns } from "./MultiDashboard.vue?vue&type=template&id=6ff5058c&"
import script from "./MultiDashboard.vue?vue&type=script&lang=js&"
export * from "./MultiDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports